import { getCode3Widget } from './code3Widget';
/**
 * []英文中括号+限制3个大写字母，eg：[CAN]，转换成【】中文中括号+城市名，eg：【广州】
 * @export
 */
export default function transformStatusCodeMsg(msg, lang) {
    if (!msg)
        return msg;
    return msg.replace(/\[[A-Z]{3,3}\]/g, function (m) {
        var name = getCode3Widget(m.replace(/\[|\]/g, ''), lang).cityName;
        return name ? "\u3010" + name + "\u3011" : '';
    });
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/transformStatusCodeMsg.js
// module id = null
// module chunks = 